<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/car_brands'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
               <div class="label-base pb-1">Nombre</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  solo
                  hide-details="auto"
                  class="input-base"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
        status: state => state.Car_brands.status,
      })
    },
    data() {
      return {
        storeName: 'Car_brands',
        parentStoreName: 'Car_brands',
        title: "Marca de auto",
        data: {
          name: '',
        }
      }
    }
  }
</script>
